import { Comment } from './comment';
import { User } from './user';
import { Video } from './video';

enum ReportStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  REJECTED = 'REJECTED',
}

enum ReportType {
  VIDEO = 'VIDEO',
  COMMENT = 'COMMENT',
  USER = 'USER',
}

interface Report {
  id: string;
  createdAt: number;
  comment?: Comment;
  commentId: string;
  reason: string;
  reporterId: string;
  reporter: User;
  userId: string;
  user: User;
  videoId: string;
  video: Video;
  status: ReportStatus;
  type: ReportType;
  moderationReason?: string;
  isNotified?: boolean;
  resolvedAt?: number;
  thumbnail?: string;
}

interface ModerationReason {
  code: string;
  title: string;
  description: string;
}

interface ReportStat {
  reportCreated: number;
  reportCreatedByDay: number;
  reportCreatedByWeek: number;
}

export { ReportType, ReportStatus };

export type { ModerationReason, Report, ReportStat };
